// lib/workspace-version-thumbnail.ts

// Fixed on purpose: the version strip scales with the zoom, so a bitmap sized to the card would be re-rendered on every zoom change.
export const VERSION_THUMBNAIL_MAX_SIDE = 2048;

export const resolveVersionThumbnailSize = (width: number, height: number): { width: number; height: number } => {
  if (!(width > 0 && height > 0)) return { width: 0, height: 0 };
  const scale = Math.min(1, VERSION_THUMBNAIL_MAX_SIDE / Math.max(width, height));
  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale)),
  };
};
